import { createApp } from 'vue'
import App from './App.vue'
import PrimeVue from 'primevue/config';
import Button from 'primevue/button';
import Checkbox from 'primevue/checkbox';
import AutoComplete from "primevue/autocomplete";
import mitt from 'mitt';

import 'primevue/resources/themes/nova-vue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import './assets/css/main.css';
import './assets/css/button.css';
import './assets/css/input.css';
import './assets/css/typography.css';

window.storeLocatorBus = mitt();

const app = createApp(App);

app.use(PrimeVue);
app.component('Button', Button);
app.component('Checkbox', Checkbox);
app.component('AutoComplete', AutoComplete)
app.mount('#store-locator-search');
